export default __webpack_public_path__ + "static/media/burger.82477e17.svg";